export default {
  "menu.SelfAuditRecordListPage": "安全自检",

  'app.selfAuditRecord.attr.status.enum.draft': '待审核',
  'app.selfAuditRecord.attr.status.enum.checked_success': '审核通过',
  'app.selfAuditRecord.attr.status.enum.checked_failure': '审核失败',
}